import type {
  ExcalidrawElement,
  ExcalidrawTextContainer,
} from "@excalidraw/element/types";
import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";

// Open the inline text editor on a freshly created mindmap node.
//
// We call the fork-exposed `excalidrawAPI.startTextEditing` (added under a
// DRAWOLA:CUSTOM block in packages/excalidraw/components/App.tsx) which is
// the same entry point Excalidraw's own double-click handler uses. This
// avoids the synthetic-dblclick approach, which the upstream
// shouldHandleBrowserCanvasDoubleClick guard rejects after the user has
// already interacted with the canvas.
//
// requestAnimationFrame defers the call to the next paint so the new
// element added by the prior updateScene call is laid out.
export const focusNewMindmapNodeForEditing = (
  api: ExcalidrawImperativeAPI,
  rect: ExcalidrawElement,
) => {
  if (typeof window === "undefined") {
    return;
  }
  window.requestAnimationFrame(() => {
    api.startTextEditing({
      sceneX: rect.x + rect.width / 2,
      sceneY: rect.y + rect.height / 2,
      container: rect as ExcalidrawTextContainer,
      autoEdit: true,
    });
  });
};
